import { Group, SimpleCell, Text } from '@vkontakte/vkui';
import { Container } from '@mui/material';
import CardSlider from './CardSlider';

function ResultView({ data, token }) {
    const items = data.items;

    if (items.length === 0) {
        return (
            <Text weight="2">
                Не удалось найти новомученников
            </Text>
        );
    }

    return (
        <Group>
            <SimpleCell>
                <Container className="container" maxWidth="xs">
                    <CardSlider
                        cards={items}
                        token={token}
                    />
                </Container>
            </SimpleCell>
        </Group>
    );
}

export default ResultView;
